export default {
  SEARCH_INVESTMENT_PROVIDER_QUERY: Symbol.for('SEARCH_INVESTMENT_PROVIDER_QUERY'),
  INVESTMENT_PROVIDER_REPOSITORY: Symbol.for('INVESTMENT_PROVIDER_REPOSITORY'),
  INVESTMENT_PROVIDER_STATE_MANAGER: Symbol.for('INVESTMENT_PROVIDER_STATE_MANAGER'),
};
